import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import styles from './Collapse.module.scss';

export default class Collapse extends Component {
  static propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
  };

  static defaultProps = {
    className: ''
  };

  state = {
    isCollapsed: false
  };

  render() {
    const { className, title } = this.props;
    const { isCollapsed } = this.state;

    return (
      <div className={`${className}`}>
        <span
          className={styles.CollapseBoxButton}
          onClick={() => this.toggleCollapse()}
        >
          {title}
        </span>
        <FontAwesomeIcon
          className={`${styles.Arrow} ${isCollapsed ? styles.Collapsed : ''}`}
          icon={['fas', isCollapsed ? 'angle-up' : 'angle-down']}
        />
        <div
          className={`${styles.CollapseBox} ${
            isCollapsed ? styles.Collapsed : ''
          }`}
        >
          {this.props.children}
        </div>
      </div>
    );
  }

  toggleCollapse() {
    this.setState({
      isCollapsed: !this.state.isCollapsed
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Collapse/Collapse.js